const DISCOVER_ROUTE_CACHE_KEY = "asasiasaDiscoverRouteSnapshot";
const DISCOVER_ROUTE_CACHE_MAX_AGE = 2 * 60 * 1000;

const normalizeSnapshot = (snapshot = {}) => ({
  discoverCommunities: Array.isArray(snapshot.discoverCommunities)
    ? snapshot.discoverCommunities
    : [],
  discoverPeople: Array.isArray(snapshot.discoverPeople)
    ? snapshot.discoverPeople
    : [],
});

export const writeDiscoverRouteCache = (snapshot) => {
  try {
    sessionStorage.setItem(
      DISCOVER_ROUTE_CACHE_KEY,
      JSON.stringify({
        cachedAt: Date.now(),
        snapshot: normalizeSnapshot(snapshot),
      }),
    );
  } catch {
    // Cache is only a navigation optimization.
  }
};

export const mergeDiscoverRouteCache = (partialSnapshot) => {
  writeDiscoverRouteCache({
    ...(readDiscoverRouteCache() || {}),
    ...partialSnapshot,
  });
};

export const readDiscoverRouteCache = () => {
  try {
    const raw = sessionStorage.getItem(DISCOVER_ROUTE_CACHE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (
      !parsed?.cachedAt ||
      Date.now() - parsed.cachedAt > DISCOVER_ROUTE_CACHE_MAX_AGE
    ) {
      sessionStorage.removeItem(DISCOVER_ROUTE_CACHE_KEY);
      return null;
    }

    return normalizeSnapshot(parsed.snapshot);
  } catch {
    return null;
  }
};

export const buildDiscoverCommunitiesNavigationState = () => {
  const cached = readDiscoverRouteCache();
  if (!cached?.discoverCommunities?.length) return undefined;

  return {
    prefetchedDiscoverCommunities: cached.discoverCommunities,
  };
};

export const buildMeetPeopleNavigationState = () => {
  const cached = readDiscoverRouteCache();
  if (!cached?.discoverPeople?.length) return undefined;

  return {
    prefetchedPeople: cached.discoverPeople,
  };
};
